module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.43.39.9d90bd11.jpg";